import React from "react";
import {Col} from 'reactstrap'
import {useParams} from "react-router-dom";
import OpeningHours from "../../../components/openinghours/OpeningHours";
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux';
import * as api from "../../../core/api";
import {toastSuccess} from "../../../core/utils/appUtil";
import handleError from "../../../core/utils/errorUtil";
import ResourcePage from "./ResourcePage";
import {openResourceOpeningHoursPage} from "../../../actions/resources";
import {openPartnerOpeningHoursPage} from "../../../actions/partners";
import {createAction} from "../../../core/utils/appUtil";
import {OPENING_HOUR_FORM_SAVED} from "../../../reducers/openingHourForm";

let ResourceAvailabilityPage = () => {

    let params = useParams();

    let resourceId = params.id

    let {availability_type: availabilityType} = useSelector(state => state.openingHourForm)

    let dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(openResourceOpeningHoursPage(resourceId))
    }, [resourceId, dispatch])

    let apiCall = (data) => {
        let request = api.updateResourceOpeningHours({
            availability_type: availabilityType,
            opening_hours: data
        }, resourceId, []);
        return request.then(() => {
            dispatch(createAction(OPENING_HOUR_FORM_SAVED))
            toastSuccess('Zapisano!')
        }).catch(error => handleError(error, dispatch))
    }

    let [loading, setLoading] = React.useState(false)

    let submit = async (data) => {
        setLoading(true);
        await apiCall(data);
        setLoading(false);
    }

    let resetForm = () => {
        dispatch(openPartnerOpeningHoursPage(resourceId))
    }

    return <ResourcePage resourceId={resourceId}>
        <Col lg={{size: 6, offset: 3}}>
            <OpeningHours resetForm={resetForm} onSubmit={submit} duringSubmit={loading} allowChangeAvailabilityType={true}/>
        </Col>
    </ResourcePage>
}

export default ResourceAvailabilityPage
